import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import UserService from '../../../../../../services/user.api';

function useDeleteUser() {
  const [error, setError] = useState('');

  const deleteUser = useCallback(async (userId: string) => {
    try {
      await UserService.deleteUser(userId);
    } catch (e) {
      const error = e as AxiosError;
      setError(error.message);
    }
  }, []);

  return {
    deleteUser,
    error,
  };
}

export default useDeleteUser;
